import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children, requireAuth = true }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  
  useEffect(() => {
    // تسجيل محاولة الوصول للصفحات المحمية
    if (requireAuth && !user && !loading) {
      console.log('محاولة وصول غير مصرح بها إلى:', location.pathname);
    }
  }, [user, loading, requireAuth, location]);

  // انتظار تحميل حالة المصادقة
  if (loading) {
    return <div>جاري التحميل...</div>;
  }

  if (requireAuth && !user) {
    // حفظ المسار الحالي للعودة إليه بعد تسجيل الدخول
    console.log('توجيه إلى صفحة تسجيل الدخول من:', location.pathname);
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (!requireAuth && user) {
    // إذا كان المستخدم مسجل الدخول ويحاول الوصول إلى صفحة تسجيل الدخول
    console.log('مستخدم مسجل يحاول الوصول إلى صفحة تسجيل الدخول');
    const intendedPath = location.state?.from?.pathname || '/';
    return <Navigate to={intendedPath} replace />;
  }

  return children;
};

export default ProtectedRoute;